import { CartographySummaryDto, RoomType } from 'src/types/cartography.types';

/** Rooms users actually call "Chambre": the only ones counted in the big "Chambres" figure. */
const BEDROOM_TYPES = [RoomType.BEDROOM, RoomType.MASTER_BEDROOM] as const;

/** Other sleeping rooms, listed in the sub-caption so nothing is lost from the count. */
export const OTHER_SLEEPING_ROOM_TYPES = [
  RoomType.MEZZANINE,
  RoomType.DORMITORY,
  RoomType.STUDIO_APARTMENT,
] as const;

const countOfType = (summary: CartographySummaryDto | undefined, type: RoomType): number =>
  summary?.sleepingRooms.byType.find(entry => entry.key === type)?.count ?? 0;

/**
 * "Chambres" figure shared by every screen (Cartography and Dashboard). `bedroomCount` from the
 * API also includes mezzanines, dormitories and studios, which users don't read as bedrooms —
 * showing it on one screen and this figure on another made the same label give two numbers.
 */
export const countBedrooms = (summary: CartographySummaryDto | undefined): number =>
  BEDROOM_TYPES.reduce((sum, type) => sum + countOfType(summary, type), 0);

export const countOtherSleepingRooms = (
  summary: CartographySummaryDto | undefined
): { type: RoomType; count: number }[] =>
  OTHER_SLEEPING_ROOM_TYPES.map(type => ({ type, count: countOfType(summary, type) })).filter(
    entry => entry.count > 0
  );
